import { Tooltip } from '@material-ui/core';
import ActionButton, { MENU_BUTTON_CATEGORY } from 'src/components/UI/ActionButton';
import GetAppIcon from '@material-ui/icons/GetApp';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { ButtonProps } from '@material-ui/core/Button/Button';
import { t } from 'src/lib/language';
import { openDialog } from 'src/redux/actions/dialogActions';
import { DIALOGS } from 'src/models/DialogModel';

interface Props extends ButtonProps {
  eventId?: number;
}

const ExportTicketButton = (props: Props) => {
  const { disabled, eventId } = props;
  const dispatch = useAppDispatch();
  const lang = useSelector((state: Store) => state.language.language ?? 'en');

  const handleOpen = () => {
    dispatch(openDialog({ dialog: DIALOGS.ticketExport }));
  };

  return (
    <Tooltip
      title={t(lang, 'menus.export_ticket')}
      placement="top-start">
      <span>
        <ActionButton
          data-testid="export-ticket-button"
          variant="outlined"
          category={MENU_BUTTON_CATEGORY.download}
          onClick={handleOpen}
          disabled={disabled || !eventId}>
          <GetAppIcon />
        </ActionButton>
      </span>
    </Tooltip>
  );
};

export default ExportTicketButton;
